/**
 * BackButton - Consistent navigation back button
 * Renders "← Back to {label}" with standard styling.
 */

interface BackButtonProps {
  /** What we're going back to, e.g. "Market", "Outfitters" */
  label: string;
  onClick: () => void;
  className?: string;
}

export function BackButton({ label, onClick, className = '' }: BackButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 text-gray-400 hover:text-white transition-colors min-h-[48px] ${className}`.trim()}
    >
      <span className="text-xl">&larr;</span>
      <span>Back to {label}</span>
    </button>
  );
}
